import { render, staticRenderFns } from "./ConcursosPublicosComponent.vue?vue&type=template&id=417a45e0&scoped=true&"
import script from "./ConcursosPublicosComponent.vue?vue&type=script&lang=ts&"
export * from "./ConcursosPublicosComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ConcursosPublicosComponent.vue?vue&type=style&index=0&id=417a45e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417a45e0",
  null
  
)

export default component.exports